import React from "react";

export const Information = (props) => {
  const renderList = (items) => {
    return (
      <ul>
        {items.map((item, index) => (
          <li style={styles.listItem} key={index}>
            {item}
          </li>
        ))}
      </ul>
    );
  };

  const renderSubsections = (subsections) => {
    return subsections.map((sub, index) => (
      <div key={index}>
        <h4 style={styles.subTitle}>{sub.subtitle}</h4>
        <p style={styles.text}>{sub.details}</p>
      </div>
    ));
  };

  const renderRow = (section, index) => {
    const isReversed = index % 2 !== 0;
    return (
      <div
        className={`row content-row ${isReversed ? "flex-md-row-reverse" : ""}`}
        key={index}
      >
        <div className="col-xs-12 col-md-6 content-centered">
          <img
            src={section.image ? section.image : "img/default.png"}
            className="img-responsive"
            alt=""
          />
        </div>
        <div
          className="col-xs-12 col-md-6 content-centered"
          style={{ margin: "auto" }}
        >
          <div className="information-text">
            <h2 style={styles.title}>{section.title}</h2>
            {section.paragraph && (
              <p style={styles.text}>{section.paragraph}</p>
            )}
            {section.listTitle && (
              <h4 style={styles.subTitle}>{section.listTitle}</h4>
            )}
            {section.listItems && renderList(section.listItems)}
            {section.subsections && renderSubsections(section.subsections)}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div id="information" style={styles.container}>
      <div className="container">
        {props.data && props.data.header && (
          <div className="row content-row">
            <div
              className="col-xs-12 col-md-6 content-centered"
              style={{ margin: "auto" }}
            >
              <div className="information-text">
                <h2 style={styles.title}>{props.data.header.title}</h2>
                <p style={styles.text}>{props.data.header.paragraph}</p>
              </div>
            </div>
            <div className="col-xs-12 col-md-6 content-centered">
              <img
                src={props.data.header.image}
                className="img-responsive"
                alt=""
              />
            </div>
            <div
              className="col-lg-12 col-sm-12 col-xs-12"
              style={{ display: "flex" }}
            >
              <a href="#product" className="btn-custom" style={styles.button}>
                {props.data.header.ButtonBuy}
              </a>
            </div>
          </div>
        )}
      </div>

      <div className="full-width-section">
        <div className="container">
          {props.data &&
            Object.keys(props.data)
              .filter((key) => key !== "header")
              .map((key, index) => renderRow(props.data[key], index))}
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    position: "relative",
    overflow: "hidden",
    backgroundColor: "#fff",
  },
  title: {
    fontSize: "25px",
    margin: "0",
    wordBreak: "break-word",
    overflowWrap: "break-word",
    textAlign: "center",
    maxWidth: "90%",
  },
  subTitle: {
    fontSize: "22px",
    margin: "0",
    wordBreak: "break-word",
    overflowWrap: "break-word",
    textAlign: "center",
    maxWidth: "90%",
  },
  text: {
    fontSize: "18px",
    margin: "0",
    wordBreak: "break-word",
    overflowWrap: "break-word",
    textAlign: "center",
    maxWidth: "90%",
  },
  listItem: {
    fontSize: "18px",
    wordBreak: "break-word",
    overflowWrap: "break-word",
  },
  button: {
    margin: "auto",
    marginTop: "50px",
    padding: "10px 20px",
    backgroundColor: "#1a9766",
    color: "#fff",
    borderRadius: "5px",
    textAlign: "center",
    fontSize: "16px",
    fontWeight: "bold",
    textDecoration: "none",
  },
};

const responsiveStyles = `
  @media (max-width: 768px) {
    h2 {
      font-size: 22px;
    }
    h4 {
      font-size: 20px;
    }
    p {
      font-size: 16px;
    }
  }
`;

const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = responsiveStyles;
document.head.appendChild(styleSheet);
